var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 427.4 574.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.38,
    y: 272.38,
    width: 210.63,
    height: 29.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.38,
    y: 167.42,
    width: 210.63,
    height: 29.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.38,
    y: 377.34,
    width: 210.63,
    height: 29.36
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M427.37,21.29c-.86-16.98-19.88-26.69-34.55-18.11l-76.91,44.99c-3.04,1.78-6.79,1.83-9.87,.13L228.17,5.52c-9.01-4.95-19.93-4.94-28.93,.03L120.74,48.84c-3.11,1.71-6.9,1.65-9.95-.17L34.64,3.32C20.01-5.4,.89,4.28,.03,21.29c-.02,.42-.03,.85-.03,1.28V551.55c0,.43,.01,.86,.03,1.29,.86,16.97,19.88,26.69,34.55,18.11l76.91-45c3.04-1.77,6.79-1.82,9.87-.13l77.87,42.78c9.01,4.95,19.93,4.94,28.93-.02l78.5-43.3c3.11-1.71,6.9-1.65,9.95,.17l76.15,45.36c14.63,8.71,33.75-.97,34.61-17.97,.02-.43,.03-.86,.03-1.29V22.57c0-.43-.01-.86-.03-1.28Zm-29.33,516.87c0,3.93-4.32,6.33-7.65,4.24l-63.75-39.89c-9.23-5.77-20.87-6.09-30.4-.84l-77.72,42.86c-3,1.66-6.64,1.66-9.64,.01l-77.21-42.41c-9.45-5.19-20.96-4.92-30.14,.73l-64.55,39.65c-3.33,2.05-7.62-.35-7.62-4.26V35.96c0-3.93,4.32-6.32,7.65-4.24l63.75,39.89c9.23,5.78,20.87,6.1,30.4,.84L208.88,29.59c3-1.65,6.64-1.66,9.64-.01l77.21,42.42c9.45,5.19,20.96,4.91,30.14-.73l64.55-39.66c3.33-2.04,7.62,.35,7.62,4.26v502.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billingIcon.b31ce3e3fb5faf898c16152c5e994ba6.svg";
export { ForwardRef as ReactComponent };